import { VBaseButton, useButton } from '../VBaseButton';
import { ProgressActivity } from '../asset';
import { joinCn } from '../util';
import { BUTTON_SIZE, BUTTON_VARIANT } from './constant';
import twStyle from './style';
import type { VButtonProps } from './type';

const VButton = (
  props: React.PropsWithChildren<
    VButtonProps & React.ComponentPropsWithRef<'button'>
  >,
) => {
  const {
    children,
    ref,

    className,
    disabled,
    fluid = false,
    loading = false,
    outlined = false,
    size = BUTTON_SIZE.MD,
    variant = BUTTON_VARIANT.PRIMARY,

    onClick,
    ...buttonProps
  } = props;
  const { isLoading, handleClick } = useButton({ disabled, loading, onClick });
  const style = twStyle({ fluid, outlined, size, variant });

  return (
    <VBaseButton
      ref={ref}
      className={joinCn(style.button, className)}
      disabled={disabled}
      loading={isLoading}
      outlined={outlined}
      onClick={handleClick}
      {...buttonProps}
    >
      {isLoading ? (
        <ProgressActivity
          aria-label="loading-spinner"
          className="animate-spin"
          role="status"
        />
      ) : null}
      {children}
    </VBaseButton>
  );
};

export default VButton;
